import type { Cable, ElectricalGroup } from "@/shared/plan";

export const electricalGroupConnectivity = (
	group: ElectricalGroup,
	cables: Record<string, Cable>,
	panelIds: ReadonlySet<string>,
) => {
	const groupCables = Object.values(cables).filter((cable) => cable.groupId === group.id);
	const panelAvailable = !!group.panelId && panelIds.has(group.panelId);
	const neighbours = new Map<string, string[]>();
	for (const cable of groupCables) {
		neighbours.set(cable.from, [...(neighbours.get(cable.from) ?? []), cable.to]);
		neighbours.set(cable.to, [...(neighbours.get(cable.to) ?? []), cable.from]);
	}
	const reachable = new Set<string>();
	const queue = panelAvailable && group.panelId ? [group.panelId] : [];
	for (let index = 0; index < queue.length; index++) {
		const current = queue[index];
		if (reachable.has(current)) continue;
		reachable.add(current);
		for (const next of neighbours.get(current) ?? []) {
			if (!reachable.has(next)) queue.push(next);
		}
	}
	return {
		panelAvailable,
		cableCount: groupCables.length,
		disconnectedCount: groupCables.filter(
			(cable) => !reachable.has(cable.from) || !reachable.has(cable.to),
		).length,
	};
};
